// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-video-container video{position:absolute;object-fit:cover;object-position:var(--hero-video-position);width:100%;height:100%;top:0;left:0}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Hero/HeroVideo/HeroVideo.scss"],"names":[],"mappings":"AACI,4BACI,iBAAA,CACA,gBAAA,CACA,0CAAA,CACA,UAAA,CACA,WAAA,CACA,KAAA,CACA,MAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
